import aboutpic from './components/Access/lonebots_logo.png'

const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://jishnusuresh.me/',
  title: 'JS.',
}

const about = {
  photo: aboutpic,
  // all the properties are optional - can be left empty or deleted
  fname: 'Jishnu',
  lname: 'Suresh',
  role: 'Developer  |  Robots  |  Travel',
  nickname: 'lonebots',
  description:
    "Keep it simple and stupid. That's how I work. Engineer. Developer. aspiring robotisit.",
  resume:
    'https://drive.google.com/file/d/1PYr2yktnL-_eUOMtfksfIdVTT4xjB_8Z/view?usp=drive_link',
  social: {
    linkedin: 'https://www.linkedin.com/in/lonebots/',
    github: 'https://github.com/lonebots',
    instagram: 'https://instagram.com/lonebots',
    twitter: 'https://twitter.com/lonebots',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'Noteit',
    description:
      'A simple note-taking application that allows users to create, read, update, and delete notes, providing a convenient way to organize and manage their thoughts, tasks, and important information along with a clean and intuitive user interface. Get started and boost your productivity today!',
    stack: ['MongoDB', 'Express', 'React Js', 'Node'],
    sourceCode: 'https://github.com/lonebots/noteit',
    livePreview: 'https://noteit-taupe.vercel.app/',
  },
  {
    name: 'Blood Bank App',
    description:
      'A simple web application that can be used for the efficient management of a blood bank. The project was developed as a part of the Application Software Developement Lab during my BTech degree. The project incorporate a minimalistic UI which very much user friendly.',
    stack: ['Node', 'React Js', 'Express', 'MySQL'],
    sourceCode: 'https://github.com/lonebots/Blood-Bank',
    livePreview: 'https://lonebots.github.io/blood-bank-app/',
  },
  {
    name: 'IoT - Water Meter Reader',
    description:
      'An IoT based automatic water consumption monitoring system for analog water meters. This was done for my BTech final year project with a my team. The device is really usefull in taking water meter readings to monitor consumption and save water.',
    stack: [
      'RaspberryPi',
      'Python',
      'ML',
      'React',
      'MySQL',
      'NodeJs',
      'AmazonEC2',
    ],
    sourceCode: 'https://github.com/lonebots/water-meter-project',
    livePreview: 'https://watermeterapp.netlify.app/',
  },
  {
    name: 'Image Classifier',
    description:
      'Simple Image Classifier app build as a part of TinkerHub Practical AI BootCamp. The classifer efficiently makes classification among pictures supplied to it as a TRUCK of SHIP. The classification model is build using Tensorflow.',
    stack: ['Tensorflow', 'Python', 'Numpy'],
    sourceCode: 'https://github.com/lonebots/binary_image_classifier',
    livePreview: '_',
  },
  {
    name: 'Social Media Server',
    description:
      'A REST based API sever implementation done as a part of self-learning. The project helped me explore the MERN stack as a prominent Back-End developemnet technolgy. The learning curve was pretty much steap.',
    stack: ['Typescript', 'Node', 'Zod', 'Express', 'MongoDB'],
    sourceCode: 'https://github.com/lonebots/socialmedia-api-server',
    livePreview: '_',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'JavaScript',
  'TypeScript',
  'MySQL',
  'Redux',
  'Git',
  'MERN',
  'ROS',
  'Tensorflow',
  'Pytorch',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'jishnusurajila@gmail.com',
  blog: 'https://lonebots.hashnode.dev/',
  know_more: 'https://github.com/lonebots?tab=repositories',
}

export { header, about, projects, skills, contact }
